import { Component } from '@angular/core';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html'
})

export class PrivacyComponent { }



// WEBPACK FOOTER //
// ./src/components/shared/privacy/privacy.component.ts